import React from 'react';
import styled from 'styled-components';
import { Container, InternalLink, Heading, media } from '../../ui-components';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import OfficeCard from '../../components/office-card';

import Office from '../../models/Office/Office';

/**
 * Component that renders renderOfficeCarousel
 *
 * @component renderOfficeCarousel
 * 
 * @param {array} offices
 * 
 * @returns {JSX}
 */
const renderOfficeCarousel = (offices, title = 'Credera offices', linkText = 'View All') => {
  const filteredOffices = offices.filter(office => {
    if (office?.internal?.type === 'ContentfulOffice') {
      return office;
    }
  });

  const officeCards = filteredOffices.map(office => {
    return (
      <CardWrapper key={office.slug}>
        <OfficeCard office={new Office(office)} secondary />
      </CardWrapper>
    );
  });

  return (
    <>
      <OfficeSectionHeading>
        <Heading level={4}>{title}</Heading>
        <InternalLink withArrow to={'/about-us/our-offices'}>
          {linkText}
        </InternalLink>
      </OfficeSectionHeading>
      <DesktopCarousel>
        <DesktopScrollingContainer>{officeCards}</DesktopScrollingContainer>
      </DesktopCarousel>
      <MobileColumnContainer>{officeCards}</MobileColumnContainer>
    </>
  );
};

const OfficeSectionHeading = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding-top: 0px;
  padding-bottom: 40px;

  @media screen and (max-width: ${media.smallTop}) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;

const CardWrapper = styled.div`
  position: relative;

  @media screen and (max-width: ${media.mediumTop}) {
    width: 100%;
  }
`;

const DesktopScrollingContainer = styled.div`
  display: flex;
  padding-bottom: 120px;
  position: relative;
  padding-left: calc((100% - ${media.hugeBottom}) / 2 + 80px);
  padding-right: calc((100% - ${media.hugeBottom}) / 2 + 80px);
  gap: 24px;

  @media screen and (width <= ${media.hugeBottom}) {
    padding-left: 80px;
    padding-right: 80px;
  }
  @media screen and (width <= ${media.mediumTop}) {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 60px;
  }
`;

const DesktopCarousel = styled(props => <ScrollingCarousel {...props} />)`
  div {
    overflow-y: hidden;
  }

  div div {
    overflow-y: unset;
  }

  @media screen and (width <= ${media.smallTop}) {
    display: none;
  }
`;
const MobileColumnContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
  padding-bottom: 60px;
  gap: 24px;

  @media screen and (width > ${media.smallTop}) {
    display: none;
  }
`;

export default renderOfficeCarousel;
